/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

export default function Pagination({
  pages,
  setPage,
  page,
  setPosts,
}) {
  if (pages?.length > 3) {
    return (
      <div className="py-10 ">
        <ul className="flex justify-center items-center w-full !list-none gap-x-3">
          {pages.map((item) => (item.label === '&laquo; Anterior' || item.label === 'Siguiente &raquo;' ? null : (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <li
              key={item.label}
              onClick={() => {
                setPage(item.label);
                setPosts(null);
              }}
              className={`
            border border-gray-200 w-10 h-10 select-none flex rounded-full font-semibold cursor-pointer items-center justify-center
            ${
             item.label === page
               ? 'bg-brand-brown text-white pointer-events-none'
               : 'bg-brand-main text-white'
            }`}
            >
              <span className="cursor-pointer pageLink">{item.label}</span>
            </li>
          )))}
        </ul>
      </div>
    );
  }
}

Pagination.propTypes = {
  setPosts: PropTypes.func.isRequired,
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  page: PropTypes.string.isRequired,
  setPage: PropTypes.func.isRequired,
};
